import { Checkbox, Form, Row } from "antd";
import { INotificationRecipients } from "../../types";
import { useUserTypesMap } from "../../hooks/useUserTypesMap";

type NotificationOptionsProps = {
  receipients: INotificationRecipients[];
};

export const NotificationOptions = ({
  receipients,
}: NotificationOptionsProps) => {
  const { userTypesMap } = useUserTypesMap();

  return (
    <Row className="d-block mt-4">
      {receipients.map((item: INotificationRecipients, i: number) => {
        return (
          <Row className="align-start w-100 mb-2" key={i}>
            <Form.Item
              name={["notificationRecipientTypes", userTypesMap[item.userType]]}
              valuePropName="checked"
              className="mb-0 email-option"
            >
              <Checkbox>
                <Row className="d-block receipient-label">
                  <p className="my-0 text-md elipsis">{item.name}</p>
                  <span className="text-sm title elipsis">
                    {userTypesMap[item.userType]}: {item.email}
                  </span>
                </Row>
              </Checkbox>
            </Form.Item>
          </Row>
        );
      })}
    </Row>
  );
};
